<template>
  <div>
    <div class="dp_shouhuan_t">收款信息</div>
    <div class="dp_yinhang">
      <div class="dp_yinhang_t">
        <img src="../assets/images/yinhangka.png" /> 银行卡基本信息
      </div>
      <p><span>户名：</span> {{ ofpay.account_name }}</p>
      <p>
        <span>账号：</span>
        <span class="dp_yinhang_red"> {{ ofpay.account }}</span>
      </p>
      <p><span>开户行：</span> {{ ofpay.account_kaihu }}</p>
    </div>
    <div class="dp_shoukuanma_t">收款码：</div>
    <div>
      <img :src="ofpay.pay_saoma" class="dp_shoukuanma" />
    </div>
  </div>
</template>
<style scoped>
.dp_shouhuan_t {
  font-size: 0.32rem;
  font-weight: 800;
  margin-top: 0.32rem;
  text-align: center;
}
.dp_yinhang {
  padding-top: 0.2rem;
  line-height: 0.6rem;
}
.dp_yinhang img {
  width: 0.6rem;
  vertical-align: middle;
}
.dp_yinhang span {
  color: #888;
}
.dp_yinhang_t {
  margin-bottom: 0.1rem;
}
.dp_yinhang span.dp_yinhang_red {
  color: #e73124;
}
.dp_shoukuanma {
  margin: 0.2rem auto;
  width: 90%;
}
.dp_shoukuanma_t {
  margin-top: 0.2rem;
}
</style>

<script>
export default {
  name: "OfflinePay",
  props: {
    ofpay: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {};
  }
};
</script>
